import { useEffect, useState } from "react";
import "./programs.scss";
import ProgramsTemplate from "../../templates/programsTemplate/programsTemplate";
import axios from "axios";
import { baseURL } from "utilities/variables";
const Programs = () => {
  const [encabezado, setencabezado] = useState(undefined);
  const [carta1Datos, setcarta1Datos] = useState(undefined);
  const [carta2Datos, setcarta2Datos] = useState(undefined);
  const [carta3Datos, setcarta3Datos] = useState(undefined);
  const [programasOfertados, setprogramasOfertados] = useState(undefined);
  const [data, setData] = useState([
    encabezado,
    carta1Datos,
    carta2Datos,
    carta3Datos,
    programasOfertados,
  ]);
  useEffect(() => {
    let auxData = [
      encabezado,
      carta1Datos,
      carta2Datos,
      carta3Datos,
      programasOfertados,
    ];
    setData(auxData);
  }, [encabezado, carta1Datos, carta2Datos, carta3Datos, programasOfertados]);
  useEffect(() => {
    //Carta 1
    axios
      .get(baseURL + "/api/programa?populate=carta1.imagenPrincipal.imagen")
      .then((response) => {
        let auxData = response.data.data.attributes.carta1;
        let auxEasyData = {
          title1: auxData.titulo1,
          description1: auxData.descripcion1,
          title2: auxData.titulo2,
          subtitle2: auxData.subtitulo2,
          description2: auxData.descripcion2,
          imgURL: `${baseURL}${auxData.imagenPrincipal.imagen.data.attributes.url}`,
          alt: auxData.imagenPrincipal.imagen.data.attributes.alternativeText,
        };
        setcarta1Datos(auxEasyData);
      });

    axios
      .get(baseURL + "/api/programa?populate=carta2.imagenPrincipal.imagen")
      .then((response) => {
        let auxData = response.data.data.attributes.carta2;
        let auxEasyData = {
          title: auxData.titulo,
          description: auxData.descripcion,
          urlText: auxData.textoURL,
          url: auxData.url,
          imgURL: `${baseURL}${auxData.imagenPrincipal.imagen.data.attributes.url}`,
          alt: auxData.imagenPrincipal.imagen.data.attributes.alternativeText,
        };
        setcarta2Datos(auxEasyData);
      });

    axios
      .get(baseURL + "/api/programa?populate=carta3.imagenPrincipal.imagen")
      .then((response) => {
        let auxData = response.data.data.attributes.carta3;
        let auxEasyData = {
          title: auxData.titulo,
          description: auxData.descripcion,
          urlText: auxData.textoURL,
          url: auxData.url,
          imgURL: `${baseURL}${auxData.imagenPrincipal.imagen.data.attributes.url}`,
          alt: auxData.imagenPrincipal.imagen.data.attributes.alternativeText,
        };
        setcarta3Datos(auxEasyData);
      });

    //Encabezado
    axios
      .get(baseURL + "/api/programa?populate=encabezado.imagenPrincipal.imagen")
      .then((response) => {
        let auxData = response.data.data.attributes.encabezado;
        let auxEasyData = {
          title: auxData.titulo,
          subtitle: auxData.subtitulo,
          description: auxData.descripcion,
          ImgURL: `${baseURL}${auxData.imagenPrincipal.imagen.data.attributes.url}`,
          ImgAlt:
            auxData.imagenPrincipal.imagen.data.attributes.alternativeText,
        };
        setencabezado(auxEasyData);
      });

    axios
      .get(
        baseURL +
          "/api/programas-ofertados?populate=imagenPrincipal.imagen&populate=nivelFormacion"
      )
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          auxEasyData.push({
            id: value.id,
            title: value.attributes.titulo,
            description: value.attributes.descripcion,
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
            code:
              "Codigo SIA " +
              value.attributes.codigoSia +
              " - Código SNIES " +
              value.attributes.codigoSNIES,
            type: value.attributes.nivelFormacion.tipo,
            codeSIA: value.attributes.codigoSia,
            codeSNIES: value.attributes.codigoSNIES,
            date: value.attributes.fechaCreacion,
            degree: value.attributes.tituloQueOtorga,
            modality: value.attributes.modalidad,
            schedule: value.attributes.jornada,
            duration: value.attributes.duracionEstimada,
            faculty: value.attributes.facultad,
            site: value.attributes.sede,
            curricularArea: value.attributes.areaCurricularPregrado,
            totalCredits: value.attributes.creditosTotales,
            formationName: value.attributes.nivelFormacion.nombre,
            formationType: value.attributes.nivelFormacion.tipo,
          });
        });
        setprogramasOfertados(auxEasyData);
      });
  }, []);
  return (
    <div className="Programs__main-container">
      {data[1] !== undefined &&
        data[0] !== undefined &&
        data[2] !== undefined &&
        data[3] !== undefined &&
        data[4] !== undefined &&
        data[4].length > 0 && <ProgramsTemplate contentData={data} />}
    </div>
  );
};

export default Programs;
